import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class TipoActualizacionService {

  controller: string = "tipo-actualizacion/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  insert(tipoActualizacion: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'crear', tipoActualizacion, this.sesion.headers);
  }

  update(tipoActualizacion: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'actualizar/' + tipoActualizacion.id, tipoActualizacion, this.sesion.headers);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "eliminar/" + id, this.sesion.headers);
  }

  select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'select', this.sesion.headers);
  }
}
